const mediaImageReference = `
reference {
  ... on MediaImage {
    id
    image {
      altText
      url
      width
      height
    }
  }
}
`;

// Presence check only — monogramming can't be offered without a monogram
// product to price it from, and the reference comes back null when the product
// is unpublished as well as when it is unset.
const monogramProductPresence = `
monogramProduct: field(key: "monogram_product") {
  reference {
    ... on Product {
      id
    }
  }
}
`;

export const colorFields = `
id
handle
type
label: field(key: "label") { value }
color: field(key: "color") { value }
image: field(key: "image") { ${mediaImageReference} }
`;

const variantFields = `
id
title
availableForSale
currentlyNotInStock
quantityAvailable
price {
  amount
  currencyCode
}
compareAtPrice {
  amount
  currencyCode
}
selectedOptions {
  name
  value
}
image {
  altText
  url
  width
  height
}
sku
customColor: metafield(namespace: "custom", key: "custom_color") {
  value
}
backInStockDate: metafield(namespace: "custom", key: "back_in_stock_date") {
  value
}
leadTime: metafield(namespace: "custom", key: "lead_time") {
  value
}
monogram: metafield(namespace: "custom", key: "monogram") {
  reference {
    ... on Metaobject {
      handle
      ${monogramProductPresence}
    }
  }
}
matchingThreadColor: metafield(namespace: "custom", key: "matching_thread_color") {
  reference {
    ... on Metaobject {
      ${colorFields}
    }
  }
}
addOnProductVariants: metafield(namespace: "custom", key: "add_on_product_variant") {
  references(first: 20) {
    nodes {
      ... on ProductVariant {
        id
        product {
          id
        }
      }
    }
  }
}
`;

const productBaseFields = `
id
title
handle
onlineStoreUrl
priceRange {
  minVariantPrice {
    amount
    currencyCode
  }
}
compareAtPriceRange {
  minVariantPrice {
    amount
    currencyCode
  }
}
featuredImage {
  altText
  url
}
productType
vendor
tags
options {
  name
  optionValues {
    name
    swatch {
      image {
        alt
        previewImage {
          url
        }
      }
      color
    }
  }
}
variants(first: 250) {
  edges {
    node {
      ${variantFields}
    }
  }
}
countryOfManufacture: metafield(namespace: "custom", key: "country_of_manufacture") {
  value
}
itemCount: metafield(namespace: "custom", key: "item_count") {
  value
}
variantLabelOverride: metafield(namespace: "custom", key: "variant_label_override") {
  value
}
addOnProducts: metafield(namespace: "custom", key: "add_on_product") {
  references(first: 20) {
    nodes {
      ... on Product {
        id
      }
    }
  }
}
monogram: metafield(namespace: "custom", key: "monogram") {
  reference {
    ... on Metaobject {
      handle
      ${monogramProductPresence}
    }
  }
}
styleCategory: metafield(namespace: "custom", key: "style_category") {
  reference {
    ... on Metaobject {
      handle
      styleCategoryName: field(key: "style_category_name") { value }
      swatches: field(key: "swatches") { value }
    }
  }
}
sizeGuide: metafield(namespace: "custom", key: "size_guide") {
  reference {
    ... on Metaobject {
      handle
      heading: field(key: "heading") { value }
      fitNote: field(key: "fit_note") { value }
      sizeChartHeading: field(key: "size_chart_heading") { value }
      sizeChartHeaderRow: field(key: "size_chart_header_row") { value }
      sizeChartRows: field(key: "size_chart_rows") { value }
      secondarySizeChartHeading: field(key: "secondary_size_chart_heading") { value }
      secondarySizeChartHeaderRow: field(key: "secondary_size_chart_header_row") { value }
      secondarySizeChartRows: field(key: "secondary_size_chart_rows") { value }
      modelMeasurementsImage: field(key: "model_measurements_image") { reference {
        ... on MediaImage {
          id
          image {
              altText
              url
              width
              height
            }
          }
        }
      }
      modelMeasurementsChartHeading: field(key: "model_measurements_chart_heading") { value }
      modelMeasurementsHeaderRow: field(key: "model_measurements_header_row") { value }
      modelMeasurementsRows: field(key: "model_measurements_rows") { value }
    }
  }
}
`;

export const productFragment = `
  ${productBaseFields}
`;
